import { createUnlocode } from '../../Domain/NauticalLocations/IPort'

export const defaultPortForFilters = createUnlocode('NLRTM')
